import React from 'react';
import { connect } from 'react-redux';
import Checkbox from 'react-toolbox/lib/checkbox';
import { Button } from 'react-toolbox/lib/button';

import Input from 'react-toolbox/lib/input';

import { setDistributor } from '~/actions/customerGroups';
import { listByGroupId, setLot } from '~/actions/customers';
import Dialog from '~/components/Dialog';

import Styles from './users.scss';

class DistributorItem extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      CustomerGroupID: props.distributor.CustomerGroupID,
      Name: props.distributor.Name,
      Lot: props.distributor.Lot,
      Distributor: props.distributor.Distributor,
      showClients: false,
      lotCodes: {}
    };
  }

  componentWillReceiveProps(props) {
    const lotCodes = {};
    if (props.customersByGroup) {
      const list = props.customersByGroup.toJS();
      list.forEach(item => {
        lotCodes[item.CustomerID] = item.Lot;
      });
    }
    this.setState({
      CustomerGroupID: props.distributor.CustomerGroupID,
      Name: props.distributor.Name,
      Lot: props.distributor.Lot,
      Distributor: props.distributor.Distributor,
      lotCodes
    });
  }

  toggleShowClients(CustomerGroupID) {
    if (CustomerGroupID) {
      listByGroupId(
        this.props.dispatch,
        this.context.apiClient,
        CustomerGroupID
      );
    }
    this.setState({ showClients: !this.state.showClients });
  }

  renderClients() {
    if (this.props.customersByGroup) {
      const list = this.props.customersByGroup.toJS();
      const items = list.map(item => {
        const lotCode = this.state.lotCodes[item.CustomerID] || '';
        return (
          <tr key={item.CustomerID}>
            <td>
              {item.BillingCompany} ({item.BillingFirstName}
              {item.BillingLastName})
            </td>
            <td>
              <Input
                type="text"
                label="Lot code"
                value={lotCode}
                onChange={e => {
                  const codes = this.state.lotCodes;
                  codes[item.CustomerID] = e;
                  this.setState({ lotCodes: codes });
                  clearInterval(this.typeInterval);
                  this.typeInterval = setTimeout(() => {
                    setLot(
                      this.props.dispatch,
                      this.context.apiClient,
                      item.CustomerID,
                      e
                    );
                  }, 500);
                }}
              />
            </td>
          </tr>
        );
      });
      return (
        <table className={Styles.table}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Lot</th>
            </tr>
          </thead>
          <tbody>{items}</tbody>
        </table>
      );
    }
    return <div>Loading</div>;
  }

  render() {
    const { Name, Distributor, CustomerGroupID, showClients } = this.state;
    const actions = [
      {
        label: 'Update clients',
        onClick: () => {
          console.log('Update clients');
        }
      }
    ];
    return (
      <tr>
        <td>
          <Dialog
            active={showClients}
            onEscKeyDown={() => this.toggleShowClients()}
            onOverlayClick={() => this.toggleShowClients()}
            onCloseButtonClick={() => this.toggleShowClients()}
            actions={actions}
          >
            <div>{this.renderClients()}</div>
          </Dialog>
          <div className={Styles.spacer} />
        </td>
        <td>{Name}</td>
        <td>
          <Checkbox
            checked={Distributor}
            onChange={e => {
              setDistributor(
                this.props.dispatch,
                this.context.apiClient,
                CustomerGroupID,
                e
              );
            }}
          />
        </td>
        <td>
          <Button
            icon="edit"
            label="Show clients"
            primary
            onClick={() => this.toggleShowClients(CustomerGroupID)}
          />
        </td>
      </tr>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    customersByGroup: state.getIn(
      ['customers', 'groups', props.distributor.CustomerGroupID.toString()],
      false
    )
  };
};

// Setting pure: false is required for react router to work
export default connect(mapStateToProps)(DistributorItem);



// WEBPACK FOOTER //
// ./app/pages/Distributor/Distributor.js